import { useMutation, useQueryClient } from "@tanstack/react-query";
import { PortfolioKeys } from "web_myplann/Api/Portfolio/portfolioKeys";
import {
	type ClientPropertyCottageDetailResponseDTO,
	type ClientPropertyCottageEditRequestDTO,
	patchPropertyCottageIdV2,
} from "web_myplann/Infrastructure/Api/Api";
import { processResponse } from "web_myplann/Infrastructure/Api/ApiUtils";

export const usePatchPropertyCottageMutation = (id: number) => {
	const queryClient = useQueryClient();

	return useMutation<
		ClientPropertyCottageDetailResponseDTO,
		Error,
		Partial<ClientPropertyCottageEditRequestDTO>
	>({
		mutationFn: processResponse((requestContract) =>
			patchPropertyCottageIdV2(requestContract, id),
		),
		onSuccess: (data) => {
			queryClient.invalidateQueries({ queryKey: PortfolioKeys.propertyList() });
			queryClient.setQueryData(PortfolioKeys.propertyDetail(id), data);
		},
	});
};
